import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [_vm._v("Usuarios")]),
      _vm._t("default"),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c("template", { slot: "description" }, [
            _vm._v("Asignación de Usuarios y Roles"),
          ]),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { outlined: "", dense: "" },
                  on: {
                    click: function ($event) {
                      return _vm.openDownloadDialog()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("icon-download"),
                  ]),
                  _vm._v("Descargar"),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary mr-1",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.newUser },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-add")]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_crear"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary mr-1",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.massiveUploadUsers },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-account-group"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_massive_upload_users"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("botones.boton_filtrar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.filter_enabled ? "col-md-9 col-sm-12" : "col-sm-12" },
          [
            _c(
              VCard,
              [
                _c(VDataTable, {
                  staticClass: "table-inca",
                  attrs: {
                    "per-page": _vm.pagination.limit,
                    items: _vm.datos,
                    headers: _vm.fields,
                    outlined: "",
                    responsive: "",
                    hover: "",
                    small: true,
                    "sticky-header": true,
                    "item-key": "email",
                    "hide-default-footer": true,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.roles",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _vm._l(
                            item.roles.filter(function (r) {
                              return r[1].flag_active
                            }),
                            function (rol, index) {
                              return index < 2
                                ? _c(
                                    VChip,
                                    {
                                      staticClass: "mb-1 mr-1",
                                      attrs: { small: "", dense: "" },
                                    },
                                    [_vm._v(_vm._s(rol[0]))]
                                  )
                                : _vm._e()
                            }
                          ),
                          item.roles.filter(function (r) {
                            return r[1].flag_active
                          }).length > 2
                            ? _c(
                                VMenu,
                                {
                                  attrs: {
                                    rigth: "",
                                    "offset-x": "",
                                    small: "",
                                    dense: "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      small: "",
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(VIcon, [
                                                  _vm._v("mdi-dots-vertical"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    VList,
                                    { attrs: { dense: "", small: "" } },
                                    _vm._l(
                                      item.roles.filter(function (r) {
                                        return r[1].flag_active
                                      }),
                                      function (rol, index) {
                                        return index > 1
                                          ? _c(
                                              VListItem,
                                              {
                                                key: index,
                                                on: {
                                                  click: function ($event) {},
                                                },
                                              },
                                              [
                                                _c(VListItemTitle, [
                                                  _vm._v(_vm._s(rol[0])),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "item.actions",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            VBtn,
                            {
                              staticClass: "btn-icon-inca",
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.onEdit(item)
                                },
                              },
                            },
                            [_c(VIcon, [_vm._v("icon-edit")])],
                            1
                          ),
                          _c(
                            VBtn,
                            {
                              staticClass: "btn-icon-inca",
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.onDelete(item)
                                },
                              },
                            },
                            [_c(VIcon, [_vm._v("icon-delete")])],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("pagination-firestore", {
                  key: _vm.key_pagination,
                  attrs: { pagination: _vm.pagination },
                  on: { changePagina: _vm.changePagina },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(VCardTitle, { staticClass: "pointer" }, [
                      _vm._v(_vm._s(_vm.$t("titles.search_filters"))),
                    ]),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                (!_vm.isDomainItc &&
                                  !_vm.isInsightServiceManager) ||
                                (_vm.isServiceManager &&
                                  !_vm.isOrgDataManagement &&
                                  !_vm.isInsightServiceManager)
                                  ? _c(VTextField, {
                                      attrs: {
                                        value: _vm.filters.select_domain,
                                        outlined: "",
                                        dense: "",
                                        disabled: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.isInsightServiceManager ||
                                (_vm.isDomainItc &&
                                  (!_vm.isServiceManager ||
                                    _vm.isOrgDataManagement))
                                  ? _c("organizacion-component", {
                                      attrs: {
                                        show_all: false,
                                        custom_orgs: _vm.list_orgs,
                                      },
                                      model: {
                                        value: _vm.filters.select_domain,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "select_domain",
                                            $$v
                                          )
                                        },
                                        expression: "filters.select_domain",
                                      },
                                    })
                                  : _vm._e(),
                                _c(VTextField, {
                                  attrs: {
                                    type: "email",
                                    required: "",
                                    label: _vm.labels.search_email,
                                    placeholder: _vm.labels.search_email,
                                    outlined: "",
                                    dense: "",
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onBuscar($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.filters.user,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "user", $$v)
                                    },
                                    expression: "filters.user",
                                  },
                                }),
                                _c(VSelect, {
                                  attrs: {
                                    items: Object.values(_vm.rolesINCA),
                                    outlined: "",
                                    dense: "",
                                    chips: "",
                                    clearable: "",
                                    color: "primary",
                                    label: "Roles",
                                    multiple: "",
                                  },
                                  model: {
                                    value: _vm.filters.roles,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "roles", $$v)
                                    },
                                    expression: "filters.roles",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "default mr-1",
                                    attrs: { outlined: "" },
                                    on: { click: _vm.onLimpiar },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                ),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "primary",
                                    on: { click: _vm.onBuscar },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "dialogs-component",
        {
          ref: _vm.modal_usuario,
          attrs: { title: _vm.getMode() + " Asignación", width: 1200 },
        },
        [
          _c("template", { slot: "body" }, [
            _c(
              "div",
              [
                _c(
                  VForm,
                  {
                    ref: "form",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.valid,
                      callback: function ($$v) {
                        _vm.valid = $$v
                      },
                      expression: "valid",
                    },
                  },
                  [
                    _c(
                      VRow,
                      [
                        _c(
                          VCol,
                          [
                            _vm.mode != "new" ||
                            (!_vm.isDomainItc &&
                              !_vm.isInsightServiceManager) ||
                            (_vm.isServiceManager && !_vm.isOrgDataManagement)
                              ? _c(VTextField, {
                                  attrs: {
                                    label: _vm.labels.domain,
                                    value: _vm.user_edit.domain,
                                    readonly: "",
                                    filled: "",
                                    dense: "",
                                  },
                                })
                              : _vm._e(),
                            _vm.isAudienceAdmin &&
                            _vm.mode == "new" &&
                            (_vm.isDomainItc || _vm.isInsightServiceManager) &&
                            (!_vm.isServiceManager || _vm.isOrgDataManagement)
                              ? _c("organizacion-component", {
                                  attrs: {
                                    custom_orgs: _vm.list_orgs,
                                    show_all: false,
                                  },
                                  on: { change: _vm.onChangeDomain },
                                  model: {
                                    value: _vm.user_edit.domain,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.user_edit, "domain", $$v)
                                    },
                                    expression: "user_edit.domain",
                                  },
                                })
                              : _vm._e(),
                            !_vm.isAudienceAdmin &&
                            _vm.mode == "new" &&
                            (_vm.isDomainItc || _vm.isInsightServiceManager) &&
                            (!_vm.isServiceManager || _vm.isOrgDataManagement)
                              ? _c("organizacion-component", {
                                  attrs: {
                                    custom_orgs: _vm.list_orgs,
                                    show_all: false,
                                  },
                                  on: { change: _vm.onChangeDomain },
                                  model: {
                                    value: _vm.user_edit.domain,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.user_edit, "domain", $$v)
                                    },
                                    expression: "user_edit.domain",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          [
                            _vm.mode != "new"
                              ? _c(VTextField, {
                                  attrs: {
                                    label: _vm.labels.user_address,
                                    value: _vm.user_edit.email,
                                    readonly: "",
                                    filled: "",
                                    dense: "",
                                  },
                                })
                              : _vm._e(),
                            _vm.mode == "new"
                              ? _c(VTextField, {
                                  attrs: {
                                    label: _vm.labels.user_address,
                                    id: "createEmail",
                                    type: "email",
                                    required: "",
                                    placeholder: "Enter User Address",
                                    rules: _vm.rules.email,
                                    outlined: _vm.mode == "new",
                                    dense: "",
                                  },
                                  model: {
                                    value: _vm.user_edit.email,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.user_edit, "email", $$v)
                                    },
                                    expression: "user_edit.email",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(VRow, [_c(VCol)], 1),
                    _vm.mode != "view"
                      ? _c(
                          VRow,
                          [
                            _c(
                              VCol,
                              { staticClass: "text-right" },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "btn-inca-secondary",
                                    on: { click: _vm.onAddRol },
                                  },
                                  [
                                    _c(VIcon, { attrs: { small: "" } }, [
                                      _vm._v("icon-add"),
                                    ]),
                                    _vm._v(_vm._s(_vm.$t("roles.nuevo_rol"))),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      VRow,
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "12" } },
                          [
                            _c(VDataTable, {
                              key: _vm.key_roles,
                              staticClass: "table-inca mb-0",
                              staticStyle: { width: "100%" },
                              attrs: {
                                headers: _vm.fieldsRoles,
                                items: _vm.user_edit.roles,
                                "hide-default-footer": true,
                                "disable-pagination": "",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "item.rol",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      !item.edit || _vm.mode == "view"
                                        ? _c(VTextField, {
                                            attrs: {
                                              readonly: "",
                                              filled: "",
                                              value: item.rol,
                                              dense: "",
                                              "hide-details": "auto",
                                              small: "",
                                            },
                                          })
                                        : _vm._e(),
                                      (item.edit && _vm.mode != "view") ||
                                      _vm.mode == "new"
                                        ? _c(VSelect, {
                                            attrs: {
                                              outlined: "",
                                              small: "",
                                              dense: "",
                                              items: _vm.availableOptions(item),
                                              "hide-details": "auto",
                                              placeholder:
                                                _vm.$t("common.select"),
                                              rules: [
                                                function (v) {
                                                  return (
                                                    !!v ||
                                                    _vm.$t(
                                                      "common.field_required"
                                                    )
                                                  )
                                                },
                                              ],
                                            },
                                            model: {
                                              value: item.rol,
                                              callback: function ($$v) {
                                                _vm.$set(item, "rol", $$v)
                                              },
                                              expression: "item.rol",
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  },
                                },
                                {
                                  key: "item.flag_active",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c(VSwitch, {
                                        attrs: {
                                          small: "",
                                          dense: "",
                                          disabled:
                                            !item.edit || _vm.mode == "view",
                                        },
                                        model: {
                                          value: item.flag_active,
                                          callback: function ($$v) {
                                            _vm.$set(item, "flag_active", $$v)
                                          },
                                          expression: "item.flag_active",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "item.expired_date",
                                  fn: function (ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return [
                                      !item.edit || _vm.mode == "view"
                                        ? _c(VLabel, [
                                            _vm._v(_vm._s(item.expired_date)),
                                          ])
                                        : _vm._e(),
                                      _c(
                                        VMenu,
                                        {
                                          attrs: {
                                            "close-on-content-click": false,
                                            "nudge-right": 40,
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "min-width": "290px",
                                            "hide-details": "auto",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function (ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    (item.edit &&
                                                      _vm.mode != "view") ||
                                                    _vm.mode == "new"
                                                      ? _c(
                                                          VTextField,
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  "append-icon":
                                                                    "event",
                                                                  readonly: "",
                                                                  dense: "",
                                                                  outlined: "",
                                                                  "hide-details":
                                                                    "auto",
                                                                },
                                                                on: {
                                                                  "click:append":
                                                                    on.click,
                                                                },
                                                                model: {
                                                                  value:
                                                                    item.expired_date,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        item,
                                                                        "expired_date",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "item.expired_date",
                                                                },
                                                              },
                                                              "v-text-field",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          )
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: _vm.menuPicker[index],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.menuPicker,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression: "menuPicker[index]",
                                          },
                                        },
                                        [
                                          _c(VDatePicker, {
                                            on: {
                                              input: function ($event) {
                                                _vm.menuPicker[index] = false
                                              },
                                            },
                                            model: {
                                              value: item.expired_date,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "expired_date",
                                                  $$v
                                                )
                                              },
                                              expression: "item.expired_date",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.domain",
                                  fn: function (ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return [
                                      _c(
                                        VList,
                                        { attrs: { dense: "" } },
                                        _vm._l(
                                          item.ownership,
                                          function (own, index2) {
                                            return _c(
                                              VListItem,
                                              [
                                                _c(
                                                  VChip,
                                                  {
                                                    staticClass: "mr-1",
                                                    attrs: {
                                                      dense: "",
                                                      small: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        own.business_domain
                                                          .domain
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  VChip,
                                                  {
                                                    attrs: {
                                                      dense: "",
                                                      small: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        own.business_subdomain
                                                          .subdomain
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(VSpacer),
                                                (item.edit &&
                                                  _vm.mode != "view") ||
                                                _vm.mode == "new"
                                                  ? _c(
                                                      VTooltip,
                                                      {
                                                        attrs: { attach: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function (
                                                                ref
                                                              ) {
                                                                var attrs =
                                                                  ref.attrs
                                                                var on = ref.on
                                                                return [
                                                                  _c(
                                                                    VBtn,
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          staticClass:
                                                                            "btn-icon-inca",
                                                                          attrs:
                                                                            {
                                                                              icon: "",
                                                                              small:
                                                                                "",
                                                                              dense:
                                                                                "",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.onRemoveBusinessDomain(
                                                                                  index,
                                                                                  index2
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        "v-btn",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        VIcon,
                                                                        [
                                                                          _vm._v(
                                                                            "icon-remove"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "roles.quitar"
                                                              ) +
                                                                " " +
                                                                _vm.$t(
                                                                  "roles.tabla_roles.domain"
                                                                )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.actions",
                                  fn: function (ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return [
                                      (item.edit && _vm.mode != "view") ||
                                      _vm.mode == "new"
                                        ? _c(
                                            VMenu,
                                            {
                                              attrs: {
                                                top: "",
                                                "offset-x": "",
                                                value: item.open,
                                                "close-on-content-click": false,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      var attrs = ref.attrs
                                                      return [
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: {
                                                              attach: "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var attrs2 =
                                                                      ref.attrs
                                                                    var on2 =
                                                                      ref.on
                                                                    return [
                                                                      _c(
                                                                        VBtn,
                                                                        _vm._g(
                                                                          _vm._b(
                                                                            {
                                                                              staticClass:
                                                                                "btn-icon-inca",
                                                                              attrs:
                                                                                {
                                                                                  icon: "",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.onResetBusinessDomain()
                                                                                  },
                                                                              },
                                                                            },
                                                                            "v-btn",
                                                                            Object.assign(
                                                                              {},
                                                                              attrs,
                                                                              attrs2
                                                                            ),
                                                                            false
                                                                          ),
                                                                          Object.assign(
                                                                            {},
                                                                            on,
                                                                            on2
                                                                          )
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            VIcon,
                                                                            [
                                                                              _vm._v(
                                                                                "icon-objects"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "roles.agregar"
                                                                  ) +
                                                                    " " +
                                                                    _vm.$t(
                                                                      "roles.tabla_roles.domain"
                                                                    )
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c(
                                                VList,
                                                [
                                                  _c(VListItem, [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "roles.agregar"
                                                          ) +
                                                            " " +
                                                            _vm.$t(
                                                              "roles.tabla_roles.domain"
                                                            )
                                                        )
                                                      ),
                                                    ]),
                                                  ]),
                                                  _c(
                                                    VListItem,
                                                    [
                                                      _c(VSelect, {
                                                        attrs: {
                                                          small: "",
                                                          dense: "",
                                                          outlined: "",
                                                          items:
                                                            _vm.selectBusinessDomain,
                                                          "hide-details":
                                                            "auto",
                                                          label: _vm.$t(
                                                            "roles.tabla_roles.domain"
                                                          ),
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.business_domain
                                                              .domain,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.business_domain,
                                                              "domain",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "business_domain.domain",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    VListItem,
                                                    [
                                                      _c(VSelect, {
                                                        attrs: {
                                                          small: "",
                                                          dense: "",
                                                          outlined: "",
                                                          items:
                                                            _vm.filterSubdomain(
                                                              _vm
                                                                .business_domain
                                                                .domain
                                                            ),
                                                          "hide-details":
                                                            "auto",
                                                          label: _vm.$t(
                                                            "roles.tabla_roles.subdomain"
                                                          ),
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.business_domain
                                                              .subdomain,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.business_domain,
                                                              "subdomain",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "business_domain.subdomain",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    VListItem,
                                                    [
                                                      _c(VSpacer),
                                                      _c(
                                                        VBtn,
                                                        {
                                                          staticClass: "mr-1",
                                                          attrs: {
                                                            small: "",
                                                            dense: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              item.open = false
                                                              _vm.onResetBusinessDomain()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "roles.cancelar"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        VBtn,
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            dense: "",
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onAddBusinessDomain(
                                                                index,
                                                                item.open
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "roles.agregar"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.canEdit(item) && _vm.mode == "edit"
                                        ? _c(
                                            VTooltip,
                                            {
                                              attrs: { attach: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var attrs = ref.attrs
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          VBtn,
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "btn-icon-inca",
                                                                attrs: {
                                                                  icon: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onEditRow(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              "v-btn",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            !item.edit
                                                              ? _c(VIcon, [
                                                                  _vm._v(
                                                                    "icon-edit"
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                            item.edit
                                                              ? _c(VIcon, [
                                                                  _vm._v(
                                                                    "mdi-pencil-off-outline"
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    item.edit
                                                      ? _vm.$t(
                                                          "roles.cancelar_edicion"
                                                        )
                                                      : _vm.$t(
                                                          "roles.editar_fila"
                                                        )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.canEdit(item) || !item.rol
                                        ? _c(
                                            VTooltip,
                                            {
                                              attrs: { attach: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var attrs = ref.attrs
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          VBtn,
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "btn-icon-inca",
                                                                attrs: {
                                                                  icon: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onDeleteRow(
                                                                        index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              "v-btn",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _c(VIcon, [
                                                              _vm._v(
                                                                "icon-delete"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "roles.eliminar_fila"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _vm.mode == "new" || (_vm.mode == "edit" && _vm.rolesEditados)
                ? _c(
                    VBtn,
                    {
                      attrs: { id: "popover-target-1", color: "primary" },
                      on: { click: _vm.onGuadarUsuario },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-check-circle-outline"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c("dialog-confirmation-component", {
        ref: "dialogConfirmation",
        attrs: {
          title: _vm.$t("my_tasks.confirm_full"),
          text: "¿Descargar de todas las empresas?",
        },
        on: { onConfirm: _vm.onConfirm },
      }),
      _c("dialog-confirmation-component", {
        ref: "dialogConfirmationDelete",
        attrs: {
          title: "Eliminar Usuario",
          text: "¿Está seguro de eliminar el usuario?",
        },
        on: { onConfirm: _vm.onConfirmDelete },
      }),
      _c(
        "dialogs-component",
        {
          ref: "modal_carga_masiva_usuarios",
          attrs: { title: "Asignación Masiva", width: 1200 },
        },
        [
          _c("template", { slot: "body" }, [
            _c(
              "div",
              [
                _c(
                  VForm,
                  {
                    ref: "form2",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.valid2,
                      callback: function ($$v) {
                        _vm.valid2 = $$v
                      },
                      expression: "valid2",
                    },
                  },
                  [
                    _c(
                      VRow,
                      [
                        _c(
                          VCol,
                          [
                            (!_vm.isDomainItc &&
                              !_vm.isInsightServiceManager) ||
                            (_vm.isServiceManager &&
                              !_vm.isOrgDataManagement &&
                              !_vm.isInsightServiceManager)
                              ? _c(VTextField, {
                                  attrs: {
                                    label: _vm.labels.domain,
                                    value: _vm.user_edit.domain,
                                    readonly: "",
                                    filled: "",
                                    dense: "",
                                  },
                                })
                              : _vm._e(),
                            _vm.isInsightServiceManager ||
                            (_vm.isAudienceAdmin &&
                              _vm.isDomainItc &&
                              (!_vm.isServiceManager ||
                                _vm.isOrgDataManagement))
                              ? _c("organizacion-component", {
                                  attrs: {
                                    custom_orgs: _vm.list_orgs,
                                    show_all: false,
                                  },
                                  on: { change: _vm.onChangeDomain },
                                  model: {
                                    value: _vm.user_edit.domain,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.user_edit, "domain", $$v)
                                    },
                                    expression: "user_edit.domain",
                                  },
                                })
                              : _vm._e(),
                            _vm.isInsightServiceManager ||
                            (!_vm.isAudienceAdmin &&
                              _vm.isDomainItc &&
                              (!_vm.isServiceManager ||
                                _vm.isOrgDataManagement))
                              ? _c("organizacion-component", {
                                  attrs: {
                                    custom_orgs: _vm.list_orgs,
                                    show_all: false,
                                  },
                                  on: { change: _vm.onChangeDomain },
                                  model: {
                                    value: _vm.user_edit.domain,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.user_edit, "domain", $$v)
                                    },
                                    expression: "user_edit.domain",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(VCol),
                        _c(
                          VBtn,
                          {
                            attrs: { color: "primary" },
                            on: { click: _vm.onDownloadTemplate },
                          },
                          [
                            _c(VIcon, { attrs: { small: "" } }, [
                              _vm._v("icon-download"),
                            ]),
                            _vm._v(
                              _vm._s(_vm.$t("botones.boton_descargar_template"))
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          [
                            _c(VFileInput, {
                              attrs: {
                                "show-size": "",
                                counter: "",
                                outlined: "",
                                small: "",
                                dense: "",
                                label: _vm.load_csv,
                                accept: ".csv",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onLoadFile($event)
                                },
                              },
                              model: {
                                value: _vm.csvFile,
                                callback: function ($$v) {
                                  _vm.csvFile = $$v
                                },
                                expression: "csvFile",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      [
                        _c(VCol, [
                          _c("span", [
                            _vm._v(_vm._s("Usuarios ")),
                            _c("b", [_vm._v(_vm._s("válidos"))]),
                            _vm._v(_vm._s(" para registro: ")),
                            _c("b", [_vm._v(_vm._s(_vm.getRegistrosValidos))]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      [
                        _c(
                          VCol,
                          [
                            _c(VDataTable, {
                              key: _vm.key_roles_massive,
                              staticClass: "table-inca mb-0",
                              staticStyle: { width: "100%" },
                              attrs: {
                                headers: _vm.fields_massive,
                                items: _vm.load_users,
                                "hide-default-footer": true,
                                "per-page": _vm.pagination_massive.limit,
                                page: _vm.pagination_massive.current,
                              },
                              on: {
                                "update:page": function ($event) {
                                  return _vm.$set(
                                    _vm.pagination_massive,
                                    "current",
                                    $event
                                  )
                                },
                                pagination: function ($event) {
                                  _vm.pagination_massive.total =
                                    $event.itemsLength
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "item.domain",
                                  fn: function (ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.user_edit.domain)),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "item.roles",
                                  fn: function (ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return _vm._l(item.roles, function (rol) {
                                      return _c(
                                        VChip,
                                        {
                                          staticClass: "mb-1 mr-1",
                                          attrs: { small: "", dense: "" },
                                        },
                                        [_vm._v(_vm._s(rol))]
                                      )
                                    })
                                  },
                                },
                                {
                                  key: "item.observation",
                                  fn: function (ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return [
                                      _c(
                                        "ul",
                                        { staticClass: "error--text m-0 p-0" },
                                        _vm._l(
                                          item.observations,
                                          function (obs) {
                                            return _c("li", [
                                              _vm._v(_vm._s(obs)),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.actions",
                                  fn: function (ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return [
                                      _c(
                                        VBtn,
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDeleteRowMassive(
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [_c(VIcon, [_vm._v("icon-delete")])],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("pagination-vue", {
                              attrs: { pagination: _vm.pagination_massive },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { id: "popover-target-1", color: "primary" },
                  on: { click: _vm.onGuadarUsuariosMasivo },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }